<template>
  <div>
    <b-row class="mb-1">
      <b-col v-if="$can('Add', 'ClientAccount')">
        <b-button variant="primary" :to="{ name: 'ClientAccount-Add' }">
          <feather-icon icon="PlusIcon" class="mr-25" />
          <span class="text-nowrap">Add User</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Client Users">
      <b-row>
        <b-col md="3">
          <b-form-group>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              type="text"
              class="d-inline-block mr-1"
            />
          </b-form-group>
        </b-col>
      </b-row>
      <!-- search input -->

      <!-- table -->
      <vue-good-table
        :columns="columns"
        :rows="rows"
        :rtl="direction"
        :search-options="{
          enabled: true,
          externalQuery: searchTerm,
        }"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <template slot="table-row" slot-scope="props">
          <!-- Column: Name -->
          <span v-if="props.column.field === 'fullName'" class="text-nowrap">
            <b-avatar :src="props.row.avatar" class="mx-1" />
            <span class="text-nowrap">{{ props.row.fullName }}</span>
          </span>

          <!-- Column: Status -->
          <span v-else-if="props.column.field === 'recordStatus'">
            <!-- <b-badge :variant="statusVariant(props.row.recordStatus===2)">
              {{ props.row.recordStatus==2 ? "Active" : "InActive" }}
            </b-badge> -->

            <b-badge v-if="props.row.recordStatus === 2" pill variant="success">
              Active
            </b-badge>
            <b-badge
              v-else-if="props.row.recordStatus === 1"
              pill
              variant="danger"
            >
              InActive
            </b-badge>
          </span>
          <!-- <span v-else-if="props.column.field === 'accessType'">
            <b-badge :variant="accessTypeVariant(props.row.accessType)">
              {{ props.row.accessType === 1 ? "GateWay" : "Merchant" }}
            </b-badge>
          </span> -->
          <!-- <span v-if="props.column.field === 'role'">
            {{ props.row.role.name }}
          </span> -->

          <!-- Column: Action -->
          <!-- <span v-else-if="props.column.field === 'action'">
            <span v-if="user.userId !== props.row.id">
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  v-if="
                    props.row.recordStatus == 2 && $can('Update', 'Account')
                  "
                  :to="{
                    name: 'accountManagement-edit-user',
                    params: { id: props.row.id },
                  }"
                  variant="success"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$can('MarkAsActiveInActive', 'Account')"
                  variant="warning"
                  @click.native="handelMarkAsActiveInActive(props.row)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span
                    >Mark as
                    {{
                      props.row.recordStatus == 2 ? "InActive" : "Active"
                    }}</span
                  >
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$can('ResetPassword', 'Account')"
                  @click.prevent="ResetpasswordModal(props.row.username)"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Reset Password</span>
                </b-dropdown-item>
                <b-dropdown-item
                  v-if="$can('Delete', 'Account')"
                  variant="danger"
                  @click.prevent="handelDelete(props.row)"
                >
                  <feather-icon icon="TrashIcon" class="mr-50" />
                  <span>Delete</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span> -->

          <!-- Column: Common -->
          <span v-else>
            {{ props.formattedRow[props.column.field] }}
          </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                first-number
                last-number
                align="right"
                prev-class="prev-item"
                next-class="next-item"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
                <template #prev-text>
                  <feather-icon icon="ChevronLeftIcon" size="18" />
                </template>
                <template #next-text>
                  <feather-icon icon="ChevronRightIcon" size="18" />
                </template>
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>

      <b-col>
        <b-modal
          id="modal-resetPassword"
          ref="modal"
          hide-footer
          title="Reset Password"
          size="lg"
        >
          <!-- form -->
          <validation-observer ref="resetPassword">
            <b-form
              class="mt-2"
              method="POST"
              @submit.prevent="submitResetPassword()"
            >
              <!-- Email -->
              <b-form-group label="Email" label-for="Email">
                <validation-provider
                  #default="{ errors }"
                  name="Email"
                  rules="required"
                >
                  <b-form-input
                    id="name-input"
                    v-model="resetForm.username"
                    :state="errors.length > 0 ? false : null"
                    disabled
                  />
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- password -->
              <b-form-group label="New Password" label-for="reset-password-new">
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  vid="Password"
                  rules="required|password"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid' : null"
                  >
                    <b-form-input
                      id="reset-password-new"
                      v-model="resetForm.newPassword"
                      :type="password1FieldType"
                      :state="errors.length > 0 ? false : null"
                      class="form-control-merge"
                      name="reset-password-new"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="password1ToggleIcon"
                        @click="togglePassword1Visibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>
              <!-- submit button -->
              <b-button block type="submit" variant="primary">
                Reset Password
              </b-button>
            </b-form>
          </validation-observer>
        </b-modal>
      </b-col>
      <!-- loadings -->
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BAvatar,
  BButton,
  BBadge,
  BPagination,
  BOverlay,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BDropdown,
  BDropdownItem,
  BRow,
  BCol,
  BForm,
  BInputGroupAppend,
  BInputGroup,
} from "bootstrap-vue";
import { VueGoodTable } from "vue-good-table";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import axios from "@axios";
import store from "@/store";

export default {
  name: "Users",
  components: {
    BCard,
    VueGoodTable,
    BAvatar,
    BBadge,
    BButton,
    BOverlay,
    BPagination,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    BRow,
    BCol,
    ValidationProvider,
    ValidationObserver,
    BForm,
    BInputGroupAppend,
    BInputGroup,
  },
  data() {
    return {
      required,
      password1FieldType: "password",
      password2FieldType: "password",
      selectedStatus: 2,
      statusOptions: [
        { value: 2, text: "Active" },
        { value: 1, text: "InActive" },
        { value: 0, text: "All" },
      ],
      isLoading: false,
      rows: [],
      pageLength: 5,
      isDeleteModel: false,
      dir: false,
      activeRow: null,
      resetForm: {
        username: this.resetpasswordemail,
        newPassword: "",
      },
      columns: [
        {
          label: "Name",
          field: "firstName",
        },
        {
          label: "User name",
          field: "username",
        },
        {
          label: "is AccountLocked",
          field: "isAccountLocked",
        },
        {
          label: "is SuperAdmin",
          field: "isSuperAdmin",
        },
        {
          label: "Status",
          field: "recordStatus",
        },
        // {
        //   label: "Action",
        //   field: "action",
        // },
      ],
      searchTerm: "",
      editabelData: {},
    };
  },
  computed: {
    direction() {
      if (store.state.appConfig.isRTL) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.dir = true;
        return this.dir;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.dir = false;
      return this.dir;
    },
    statusVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-success",
        0: "light-danger",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    accessTypeVariant() {
      const statusColor = {
        /* eslint-disable key-spacing */
        1: "light-info",
        2: "light-primary",
        /* eslint-enable key-spacing */
      };

      return (status) => statusColor[status];
    },
    password1ToggleIcon() {
      return this.password1FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
    password2ToggleIcon() {
      return this.password2FieldType === "password" ? "EyeIcon" : "EyeOffIcon";
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      // this.$store.dispatch('config/getActionPrivilege', 'Account-View')
      // this.isLoading = true
      // axios.get('/User/api/V1.0/Account/GetAll').then(res => {
      //   this.rows = res.users
      //   this.isLoading = false
      // }).catch(() => {
      //   this.isLoading = false
      // })
      this.filterUsers();
    },
    ResetpasswordModal(id) {
      const item = this.rows.filter((i) => i.username === id);

      // eslint-disable-next-line prefer-destructuring
      this.resetForm.username = item[0].username;
      this.$bvModal.show("modal-resetPassword");
    },
    submitResetPassword() {
      this.$refs.resetPassword.validate().then((success) => {
        if (success) {
          axios
            .post("/User/api/V1.0/Password/ResetPassword", this.resetForm)
            .then((res) => {
              this.isLoading = false;
              this.$bvModal.hide("modal-resetPassword");
              this.$bvModal
                .msgBoxOk(`${res.message}`, {
                  title: "Success",
                  size: "sm",
                  buttonSize: "sm",
                  okVariant: "success",
                  headerClass: "p-2 border-bottom-0",
                  footerClass: "p-2 border-top-0",
                  centered: true,
                })
                .then((result) => {
                  if (result) {
                    this.filterUsers();
                  }
                });
            })
            .catch((res) => {
              this.isLoading = false;
              this.$bvModal.msgBoxOk(res.data.message, {
                title: "Error",
                size: "sm",
                buttonSize: "sm",
                okVariant: "success",
                headerClass: "p-2 border-bottom-0",
                footerClass: "p-2 border-top-0",
                centered: true,
              });
            });
        }
      });
    },

    handelMarkAsActiveInActive(row) {
      this.isLoading = true;
      axios
        .post("/User/api/V1.0/Account/ActivateDeactivateUser", {
          statusAction: row.recordStatus,
          userId: row.id,
        })
        .then(() => {
          this.fetchData();
          this.$swal({
            icon: "success",
            title: "Status Updated!",
            text: "Status Updated successfully.",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
          this.isLoading = false;
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
    filterUsers() {
      this.isLoading = true;
      this.$store.dispatch("config/getActionPrivilege", "ClientAccount-GetAll");
      this.rows = [];
      axios
        .get(`/api/V1.0/ClientAccount/GetAll`)
        .then((res) => {
          this.rows = res.clientUsers;
          this.isLoading = false;
        })
        .catch((res) => {
          console.log(res);
          this.$bvModal.msgBoxOk(`${res.data.message}`, {
            title: "Success",
            size: "sm",
            buttonSize: "sm",
            okVariant: "success",
            headerClass: "p-2 border-bottom-0",
            footerClass: "p-2 border-top-0",
            centered: true,
          });
          this.isLoading = false;
        });
    },
    handelDelete(row) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.isLoading = true;
          this.$http
            .delete(`/User/api/V1.0/Account/Delete?id=${row.id}`)
            .then(() => {
              this.fetchData();
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Your file has been deleted.",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.isLoading = false;
            })
            .catch((error) => {
              console.log("Error: ", error);
              // this.statusMessage(err.data)
              this.isLoading = false;
            });
        }
      });
    },
    validationForm() {
      this.$refs.simpleRules.validate().then((success) => {
        if (success) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "Form Submitted",
              icon: "EditIcon",
              variant: "success",
            },
          });
        }
      });
    },
    togglePassword1Visibility() {
      this.password1FieldType =
        this.password1FieldType === "password" ? "text" : "password";
    },
    togglePassword2Visibility() {
      this.password2FieldType =
        this.password2FieldType === "password" ? "text" : "password";
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
